import { ColorPalette } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { IIconV2WorldMarker } from 'react-give-me-map';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: IIconV2WorldMarker;
    onBackgroundChanged?: (color: string) => void;
}

export const IconMarkerStyleBackgroundSubsection = (props: Props): JSX.Element => {
    return (
        <S_IconMarkerStyleBackgroundSubsection className={props.className}>
            <SidebarSubsection title={Localization.BACKGROUND} icon={{ iconName: 'circle' }}>
                <SidebarContent>
                    <ColorPalette
                        value={props.marker.elementData.generatedBackgroundColor}
                        pickerAllowed
                        transparentAllowed
                        onChange={(color) => {
                            props.onBackgroundChanged?.(color);
                        }}
                    />
                </SidebarContent>
            </SidebarSubsection>
        </S_IconMarkerStyleBackgroundSubsection>
    );
};

const S_IconMarkerStyleBackgroundSubsection = styled.div``;
